import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import ReduxPromise from 'redux-promise';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

import Home from './component/Home';
import Step from './component/Step';

ReactDOM.render(
    <MuiThemeProvider muiTheme={getMuiTheme()}>
        <Provider>
            <Router>
                <div>
                    <Route exact path="/" component={Home}/>
                    <Route exact path="/step" render={(props) => <Step {...props} />}/>
                    {/* <Route exact path="/pembayaran" component={Pembayaran} /> */}
                </div>
            </Router>
        </Provider>
    </MuiThemeProvider>
, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js